document.addEventListener('DOMContentLoaded', () => {
  initCartDrawer();
  initScrollReveal();
  initAccordions();
});

/* AJAX Cart Drawer Actions */
function initCartDrawer() {
  const cartToggle = document.querySelector('[data-cart-toggle]');
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartOverlay = document.querySelector('[data-cart-overlay]');
  const cartClose = document.querySelector('[data-cart-close]');
  
  if (!cartDrawer) return;

  const openDrawer = () => {
    cartDrawer.classList.add('active');
    cartOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  };

  const closeDrawer = () => {
    cartDrawer.classList.remove('active');
    cartOverlay.classList.remove('active');
    document.body.style.overflow = '';
  };

  if (cartToggle) cartToggle.addEventListener('click', openDrawer);
  if (cartClose) cartClose.addEventListener('click', closeDrawer);
  if (cartOverlay) cartOverlay.addEventListener('click', closeDrawer);
}

/* IntersectionObserver scroll reveal system */
function initScrollReveal() {
  const reveals = document.querySelectorAll('.scroll-reveal');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    reveals.forEach(element => observer.observe(element));
  } else {
    // Fallback for older browsers
    reveals.forEach(element => element.classList.add('visible'));
  }
}

/* Accordion Component */
function initAccordions() {
  const accordionHeaders = document.querySelectorAll('.accordion__header');
  accordionHeaders.forEach(header => {
    header.addEventListener('click', () => {
      const content = header.nextElementSibling;
      const isOpen = header.classList.contains('active');
      
      // Close other accordions in the same group if needed
      
      if (isOpen) {
        header.classList.remove('active');
        content.style.maxHeight = null;
      } else {
        header.classList.add('active');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });
}
